import { render, staticRenderFns } from "./CustomerAcquisitionGuide.vue?vue&type=template&id=9ce0e958&scoped=true"
import script from "./CustomerAcquisitionGuide.vue?vue&type=script&lang=js"
export * from "./CustomerAcquisitionGuide.vue?vue&type=script&lang=js"
import style0 from "./CustomerAcquisitionGuide.vue?vue&type=style&index=0&id=9ce0e958&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce0e958",
  null
  
)

export default component.exports